import * as React from 'react';

import * as style from './PageLayout.css';
import { Layout } from '../Layout';

export interface IPageLayoutProps {
  header: React.ReactNode;
  searchResult: React.ReactNode;
  pagination: React.ReactNode;
}

export const PageLayout: React.FC<IPageLayoutProps> = props => {
  const { header, searchResult, pagination } = props;

  return (
    <div className={style['container']}>
      <Layout>
        <div className={style['header']}>{header}</div>
        <div className={style['content']}>{searchResult}</div>
        <div className={style['pagination']}>{pagination}</div>
      </Layout>
    </div>
  );
};
